<!-- <template>
     <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="warningModal"> 
                        Oops! Seller has not accepted the Terms and Conditions for JioMArt Ads. Please accept TnC and reload to access the portal.
                    </div>
                </div>  
            </div>  
        </div>
    </div>  
</template> -->
<template>
        <div class="unauthorized-message">
          <h1 class="error-heading">Oops!</h1>
          <p class="error-message">
            Seller has not accepted the Terms and Conditions for JioMart Ads. Please accept TnC and reload to access the portal.</p>
            <router-link to="/" @click="handleClick" class="error-button">Go back to home page</router-link>
        </div>
</template>

<script>
import { clearCookie } from '@/services/campaignService'
import { mapActions } from 'vuex'

import Header from './Header.vue'
import LeftMenu from './LeftMenu.vue'

export default {
    name: 'TncErrorPopup',
    components: {
        Header,
        LeftMenu,
    }, 
    methods: {
      ...mapActions(['setSellerId']),
      handleClick() {
        this.setSellerId('');
        clearCookie('sellerId');
      }
    }
}
</script>

<style scoped>
 .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }
    .modal-default-button {
      float: right;
    }
    .modal-enter-from, .modal-leave-to {
        opacity: 0;
    }
    .modal-enter-active .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .warningModal{
        font-family: 'Inter-Regular';
        padding: 32px;
        background: #FFFFFF;
        border-radius: 16px;
        width: 520px;
        margin: auto;
        text-align: center;
    }

    @font-face {
  font-family: "Inter-Regular";
  src: url('../assets/fonts/Inter-Regular.ttf');
}

.unauthorized-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 15%;
}

.error-heading {
  font-family: "Inter-Regular";
  font-size: 32px;
  font-weight: bold;
  color: #F44336;
  margin-bottom: 20px;
}

.error-message {
  font-family: "Inter-Regular";
  font-size: 18px;
  color: #333333;
  margin-bottom: 40px;
  text-align: center;
}

.error-button {
  font-family: "Inter-Regular";
  font-size: 16px;
  color: #FFFFFF;
  background-color: #F44336;
  padding: 10px 20px;
  border-radius: 4px;
  text-decoration: none;
}

#app {

  font-family: "Inter-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
